Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "ImportExportData";
exports.labelBodyText = "ImportExportData Body";

exports.btnExampleTitle = "CLICK ME";

exports.exportSuccess = "Your file exported to path: ";
exports.exportCsvLabel = "Export CSV";
exports.exportJsonLabel = "Export JSON";
exports.loadingText = "Loading...";

exports.jsonApiContentType = "application/json";
exports.csvApiContentType = "text/csv";
exports.exportDataEndpoint = "data_import_export/export";
exports.exportDataMethod = "GET";
exports.errorMsg = "Something went wrong."
// Customizable Area End